function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import classnames from "classnames";
import { StyledBasicButtonComponent } from "./basic-button-component.scss";
class BasicButtonComponent extends PureComponent {
    render() {
        const { textAlign, buttonConfig } = this.props;
        return /*#__PURE__*/ _jsx(StyledBasicButtonComponent, {
            className: "basic-button-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: classnames("button-wrapper", textAlign),
                children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
            })
        });
    }
}
export { BasicButtonComponent as default };
BasicButtonComponent.defaultProps = {
    paddingTop: "24px",
    paddingBottom: "24px",
    buttonConfig: _object_spread({}, Button.defaultProps)
};
